export const Tag = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_319_775)">
      <path
        d="M2.00001 6.5H14.5L17 7.7803L19.2222 6.5H22V19.5H19.2222L17 18.2197L14.5 19.5H2.00001V6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.24014 17V10.8581H5.00001V9.5H11V10.8581H8.75988V17H7.24014Z"
        fill="currentColor"
      />
      <rect x="16" y="10.5" width="2" height="1" fill="currentColor" />
      <rect x="16" y="12.5" width="2" height="1" fill="currentColor" />
      <rect x="16" y="14.5" width="2" height="1" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_319_775">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(1.14441e-05 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
